// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import clsx, { type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

export const twMerge = extendTailwindMerge({
  prefix: 'tw-',
});

export const cn = (...args: ClassValue[]) => twMerge(clsx(args));

export { type ClassValue as Argument, cn as cs };
